module.exports = __webpack_public_path__ + "img/commodities2.f8d431f8.svg";